module.exports = {
    ENG_US : 1033,
    SP_MX : 2058,
    FR : 1036,
    RU : 1049,
    NONE : 1024
};



// WEBPACK FOOTER //
// ./lib/data/language.js